import {type MouseEvent as ReactMouseEvent} from 'react';
import equal from 'fast-deep-equal/es6/react';

export const compareProps = (ignoreProps?: string[], key?: string) => {
	return (nextProps: any, lastProps: any) => equal(nextProps, lastProps);
};

export function preventContextMenu<T extends Element = Element>(
	event: ReactMouseEvent<T, MouseEvent>,
) {
	event.preventDefault();
}

export const isItemLoadedStub = () => true;

export const loadMoreItemsStub = async () => undefined;

type Ref<N = any> =
	| React.MutableRefObject<N>
	| React.Ref<N>
	| React.RefObject<N>
	| React.LegacyRef<N>
	// | ((node: N | null) => void)
	| undefined
	| null;
/**
 * When multiple refs would like to share the same node but cannot be used in a hook format.
 * Like when utilizing a ref from the children callback of `InfiniteLoader`
   @example
   <div ref={combineRefs<NodeType>(ref, anotherRef, andAnotherRef)}
 */
export function combineRefs<N = any>(...refs: Ref<N>[]) {
	return (node: N) => {
		refs.forEach((ref) => {
			if (!ref) return;
			typeof ref === 'function'
				? ref(node)
				: ((ref as React.MutableRefObject<N>).current = node);
		});
	};
}
